<script>
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions({
      add: 'arquivo/add'
    }),
    async salva () {
      try {
        let data = new FormData()
        data.append('file', this.$refs.ImagemFile.files[0])
        let file = await this.add(data)
        this.$emit('salvo', file)
      } catch (e) {
        if (e.response) {
          alert(e.response.data.message)
        } else alert(e.message)
      }
    }
  }
}
</script>

<template>
    <form class="field is-horizontal" @submit.prevent="salva">
        <div class="field-body">
            <div class="field">
                <div class="control is-expanded">
                    <input type="file" ref="ImagemFile" placeholder="Imagem"/>
                </div>
            </div>
            <div class="field is-grouped">
                <div class="control is-expanded">
                    <button class="button is-link is-success" type="submit"><i class="fa fa-check"></i></button>
                </div>
            </div>
        </div>
    </form>
</template>
